<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    withDefaults(defineProps<{ label?: string }>(), { label: "Plats" });

    const fetchPlatser = async ({ query }: { query?: string } = {}) => {
        const store = useStore();
        try {
            const params: { namn?: string } = {};
            if (query) params.namn = query;

            const { subsetName } = await store.dispatch("skreg/platser/fetchPlatser", { filterParams: params });
            const items = store.getters["skreg/platser/platsSubset"]({ subsetName, limit: 0 });

            return items.map((plats: { id: string; namn: string }) => ({ value: plats.id, label: plats.namn }));
        } catch {
            flashWarning("Kunde inte hämta platser");
        }
    };
</script>

<template>
    <KAutocomplete
        name="plats"
        :label="label"
        v-bind="$attrs"
        :options="fetchPlatser"
        :onSearch="fetchPlatser"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
